import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { Form, Table } from "react-bootstrap";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Swal from "sweetalert2";
import SplitPane from "react-split-pane";
import Pagination from "../../../Pagination";
import UseToggle from "../../../../Hooks/UseToggle";
import UpdateStudyUnblindingRequestType from "./UpdateStudyUnblindingRequestType";
import AddNewStudyUnblindingRequestType from "./AddNewStudyUnblindingRequestType";
import DeletedStudyUnblindingRequestType from "./DeletedStudyUnblindingRequestType";
import StudyUnblindingRequestTypeActivities from "./StudyUnblindingRequestTypeActivities";
import { eiwrsUnblindingRequestTypeServices } from "../../../../APIServices/EIWRS/UnblindManagement/eiwrsUnblindingRequestTypeServices";

const StudyUnblindingRequestTypeDataList = ({ onMouseDown, tableRef }) => {
  let { studyId } = useParams();
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2 } = UseToggle();
  const [searchData, setSearchData] = useState("");
  const [requestTypeData, setRequestTypeData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [requestTypeList, setRequestTypeList] = useState([]);
  const [unblindingRequestTypeCount, setUnblindingRequestTypeCount] = useState(0);
  const [deletedStudySiteUnblindingRequestType, setDeletedStudyUnblindingRequestType] = useState([]);
  const [deletedStudySiteUnblindingRequestTypeCount, setDeletedStudyUnblindingRequestTypeCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("activities");
  const [requestId, setRequestId] = useState("");
  const [activityLoader, setActivityLoader] = useState(false);
  const [unblindingRequestTypeActivity, setUnblindingRequestTypeActivity] = useState([]);
  const [unblindingRequestTypeActivityCount, setUnblindingRequestTypeActivityCount] = useState(0);
  const [tableColumns, setTableColumns] = useState({});
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(unblindingRequestTypeCount / itemsPerPage);

  const getEIWRSUnblindingRequestTypeData = async (e) => {
    setLoading(true);
    let data = await eiwrsUnblindingRequestTypeServices.getEIWRSUnblindingRequestTypeData(
      "active",
      studyId,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setRequestTypeList(data?.data || []);
    setUnblindingRequestTypeCount(data?.count || 0);
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedEIWRSUnblindingRequestTypeData = async (
    pageNumberDeleted,
    itemsPerPageDeleted
  ) => {
    let data = await eiwrsUnblindingRequestTypeServices.getEIWRSUnblindingRequestTypeData(
      "deleted",
      studyId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedStudyUnblindingRequestType(data?.data || []);
    setDeletedStudyUnblindingRequestTypeCount(data?.count || 0);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "EIWRSUnblindingRequestType",
      studyId,
      requestTypeData?.requestId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setUnblindingRequestTypeActivity(data?.data || []);
    setUnblindingRequestTypeActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  useEffect(() => {
    setActiveTab("activities");
  }, [requestTypeData]);

  useEffect(() => {
    getEIWRSUnblindingRequestTypeData();
  }, [searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreEIWRSUnblindingRequestType = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} Unblinding Request Type!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.type = type;
        let data =
          await eiwrsUnblindingRequestTypeServices.softDeleteRestoreEIWRSUnblindingRequestType(
            userData
          );
        if (data?.statusCode === 200) {
          getEIWRSUnblindingRequestTypeData();
          setRequestId("");
          getDeletedEIWRSUnblindingRequestTypeData();
          if (type === "restore") {
            getDeletedEIWRSUnblindingRequestTypeData(pageNumberDeleted, itemsPerPageDeleted);
            setToggle1();
          }
        }
      }
    });
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          <i
            title={isFormOpen ? "Close Form" : "Add New"}
            onClick={() => {
              setIsFormOpen(!isFormOpen);
              setRequestId("");
            }}
            className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
              }`}
          />
          <div className="vr"></div>
          {unblindingRequestTypeCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 250, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
        <div className="hstack gap-2">
          {StudyMode === "DBP Mode" &&
            deletedStudySiteUnblindingRequestTypeCount > 0 &&
            <button
              onClick={() => {
                setToggle1();
                getDeletedEIWRSUnblindingRequestTypeData(
                  pageNumberDeleted,
                  itemsPerPageDeleted
                );
              }}
              className={`updateProfile`}
            >
              Deleted History
            </button>
          }
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={requestId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddNewStudyUnblindingRequestType getEIWRSUnblindingRequestTypeData={getEIWRSUnblindingRequestTypeData} />
          )}
          {loading ? (
            <PageLoader />
          ) : unblindingRequestTypeCount === 0 ? (
            <NoDataFoundTable MSG={"Study Request Type Metadata not found!"} />
          ) : requestTypeList?.length === 0 ? (
            <NoDataFoundTable MSG={"Search Study Request Type Metadata not found!"} />
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>
                      Request Type
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 2)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Edit
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 3)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {requestTypeList?.map((requestTypeData, index) => (
                    <tr
                      key={index}
                      title="View Details"
                      className={`${requestId === requestTypeData?._id ? "highlighted" : ""
                        }`}
                      onClick={() => setIsFormOpen(false)}
                    >
                      <td
                        onClick={() => {
                          setRequestTypeData(requestTypeData);
                          setRequestId(requestTypeData?._id);
                        }}
                        className="text-center"
                      >
                        {index + 1 + startIndex}.
                      </td>
                      <td
                        onClick={() => {
                          setRequestTypeData(requestTypeData);
                          setRequestId(requestTypeData?._id);
                        }}
                      >
                        {requestTypeData?.requestType}
                      </td>
                      <td
                        className="text-center CP"
                        title={`Update ${requestTypeData?.unblindingReason}`}
                        onClick={(e) => {
                          setRequestTypeData(requestTypeData);
                          setToggle();
                          e.stopPropagation();
                        }}
                        style={{ pointerEvents: "auto" }}
                      >
                        <FaEdit className="text-muted" />
                      </td>
                      <td
                        className="text-center CP"
                        title={`Delete ${requestTypeData?.unblindingReason}`}
                        onClick={(e) => {
                          softDeleteRestoreEIWRSUnblindingRequestType(
                            requestTypeData?._id,
                            "delete"
                          );
                        }}
                      >
                        <FaTrash className={"text-danger"} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={unblindingRequestTypeCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
        {requestId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["activities"].map(
                  (tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                        }`}
                      onClick={() => setActiveTab(tab)}
                      title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setRequestId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <StudyUnblindingRequestTypeActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                unblindingRequestTypeActivity={unblindingRequestTypeActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                requestTypeData={requestTypeData}
                unblindingRequestTypeActivityCount={unblindingRequestTypeActivityCount}
                isFullScreen={isFullScreen}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateStudyUnblindingRequestType
        Show={!toggle}
        Hide={setToggle}
        requestTypeData={requestTypeData}
        setRequestId={setRequestId}
        getEIWRSUnblindingRequestTypeData={getEIWRSUnblindingRequestTypeData}
        Title={"Update Request Type"}
      />
      <DeletedStudyUnblindingRequestType
        Show={!toggle1}
        Hide={setToggle1}
        setRequestId={setRequestId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        deletedStudySiteUnblindingRequestType={deletedStudySiteUnblindingRequestType}
        getDeletedEIWRSUnblindingRequestTypeData={getDeletedEIWRSUnblindingRequestTypeData}
        deletedStudySiteUnblindingRequestTypeCount={deletedStudySiteUnblindingRequestTypeCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreEIWRSUnblindingRequestType={softDeleteRestoreEIWRSUnblindingRequestType}
        Title={"Deleted Request Type History"}
      />
    </>
  );
};

export default StudyUnblindingRequestTypeDataList;
